import axios from 'axios'
import VueAxios from 'vue-axios'


export default defineNuxtPlugin((nuxtApp) => {
    
    // Configure axios to stringify objects in POST data payload as it was in nuxt2 version
    axios.interceptors.request.use((config) => {
        if (typeof window !== 'undefined' && typeof config?.url === 'string' && config.url.startsWith('/be/')) {
            config.headers = config.headers || {}
            config.headers['x-client-referer'] = window.location.href
        }

        if(config.params){
            Object.keys(config.params).forEach((key) => {
                const x = config.params[key]
                if(x instanceof Date){
                    config.params[key] = x.toISOStringZ()
                } else if(typeof x === 'object' && !Array.isArray(x) && x !== null){
                    config.params[key] = JSON.stringify(config.params[key])
                }
            }) 
        }
       
        return config
    }, (error) => {
        return Promise.reject(error)
    })

    nuxtApp.vueApp.use(VueAxios, axios)
    
    // Provide $axios to be accessible via this.$axios in components
    return {
        provide: {
            axios: axios
        }
    }
    
    /*
    nuxtApp.axios.onError((error) => {
        if (error.response) {
            if (error.response.status === 401) {
                navigateTo('/')
            } else if (error.response.status === 403) {
                nuxtApp.$alert(nuxtApp.$i18n.t('app.unauthorizedAlert'))
            } else if (error.response.status === 400 && error.response.data.message.indexOf('VIRUS:') === 0) {
                nuxtApp.$alert(nuxtApp.$i18n.t('app.virusDetectedAlert') + ' ' + error.response.data.message.substring(6))
            
            /* zrusene, lebo aj datasource hadzu chyby
            } else if (error.response.status === 500) {
                nuxtApp.$alert(nuxtApp.$i18n.t('app.writeError'))
            * /
            }
        }
    })*/
   
})
